import React, { useEffect, useState } from "react"
import { Card, Col, Container, Form, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { toggleLoader } from "../../shared/actions/setting";
import axios from "axios";
import { getUserId } from "../../shared/authentication/authentication";
import { toast } from "react-toastify";

const initialState = {
    companyName:"",
    jobStartTime:"",
    jobEndTime:"",
    department:"",
    machine:"",
    newJobNumber:"",
    oldJobNumber:"",
    designName:"",
    length:"",
    employees:[{id:"", startTime:"", endTime:""}],
    inputMaterials:[{id:"", weight:""}],
    outputMaterials:[{name:"", weight:"", length:""}],
    wastage:[{type:"", weight:"", code:""}],
    downTime:[{type:"", startTime:"", endTime:""}],
    setup:[{startTime:"", endTime:""}],
    run:[{startTime:"", endTime:""}],
}


const TextInput = ({type, label, name, onChange, value, labelStyle, inputStyle, mainStyle, isRequired}) => {
    return <Form.Group className={mainStyle}>
        <Form.Label className={labelStyle}>{label}</Form.Label>
        <Form.Control type={type} name={name} value={value} onChange={onChange} className={inputStyle} required={isRequired}/>
    </Form.Group>
}

const DropDown = ({title, name, data, mainStyle, labelStyle, dropDownStyle, onChange, isRequired, showLabel = false, displayKey}) =>{
    return <Form.Group className={mainStyle}>
        {showLabel && <Form.Label className={labelStyle}>{title}</Form.Label>}
        <select
            className={dropDownStyle}
            name={name}
            onChange={(e) => onChange(e)}
            required ={isRequired}>
                <option defaultValue={""} value="">{title}</option>
                {
                    data && data.map((item,index) =>{
                        return <option key={index} value={item[name]}>{item[displayKey]}</option>
                    })
                }
            </select>
    </Form.Group>
}

const AddButton = ({name, onClick, buttonStyle}) => {
    return <div className={`d-flex w-full flex-row-reverse ${buttonStyle}`}>
        <button type="button" className="manualEntryBtn" onClick={onClick}>
            <span>{name}</span>
        </button>
    </div>
}

const ManualDataEntry = () =>{
    const dispatch = useDispatch();
    const [data, setData] = useState(initialState);
    const [departmentList, setDepartmentList] = useState([]);
    const [machineList, setMachineList] = useState([]);
    const [filteredMachines, setFilteredMachines] = useState([]);
    const [department, setDepartment] = useState('');
    const [machine, setMachine] = useState('');
    const [jobList, setJobList] = useState([]);
    const [job, setJob] = useState('');
    const [employeeList, setEmployeeList] = useState([]);
    const [inputList, setInputList] = useState([]);
    const [downTimeList, setDownTimeList] = useState([]);
    const [wastageTypeList, setWastageTypeList] = useState([]);
    const [jobTimeErr, setJobTimeErr] = useState('');
    const [employeeEndTimeErr, setEmployeeEndTimeErr] = useState([]);
    const [setupTimeErr, setSetupTimeErr] = useState([]);
    const [downTimeErr, setDownTimeErr] = useState([]);
    const [runTimeErr, setRunTimeErr] = useState([]);

    useEffect(() => {
        let corporateID = "60a7794ef812231385f6dce0";
        dispatch(toggleLoader(true));
        axios.get(process.env.REACT_APP_HOST + 'user/'
            + getUserId() + '/corporate/'+ corporateID +'/department' )
            .then(res => {
                setDepartmentList(res.data.content);
            }).catch(error => {
                if (error.response && error.response.status === 422) {
                    console.error(error.response.data.message);
                }
            }
        ).finally(() => {
            dispatch(toggleLoader(false))
        })

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        dispatch(toggleLoader(true));
        axios.get(process.env.REACT_APP_HOST + 'user/'
            + getUserId() + '/machine')
            .then(res => {
                setMachineList(res.data.content);
                setFilteredMachines(res.data.content);
            }).catch(error => {
                console.error(error.response?.data?.message);
            }
        ).finally(() => {
            dispatch(toggleLoader(false))
        })

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const filterMachineList = (value) =>{
        if(value === "Department"){
            setFilteredMachines(machineList);
        }else{
            let clone = machineList;
            clone = clone.filter(item => item.departmentId === value);
            setFilteredMachines(clone); 
        }
    }

    const handleChange = (event) => {
        setData({ ...data, [event.target.name] : event.target.value });
    }

    const handleMultiInputChange = (event, index, attName) => {
        let { name, value } = event.target;
        let onChangeValue = [...data[attName]];
        onChangeValue[index][name] = value;
        setData({...data, [attName]:onChangeValue});
    };

    const handleEmployeeInput = () => {
        const clone = [...data.employees, {id:"", startTime:"", endTime:""}]
        setData({...data, employees:clone});
    };

    const handleMaterialInput = () => {
        const clone = [...data.inputMaterials, {id:"", weight:""}]
        setData({...data, inputMaterials:clone});
    };

    const handleOutputMaterialInput = () => {
        const clone = [...data.outputMaterials, {name:"", weight:"", length:""}]
        setData({...data, outputMaterials:clone});
    };

    const handleWastageInput = () => {
        const clone = [...data.wastage, {type:"", weight:"", code:""}]
        setData({...data, wastage:clone});
    };

    const handleDowntimeInput = () => {
        const clone = [...data.downTime, {type:"", startTime:"", endTime:""}]
        setData({...data, downTime:clone});
    };

    const handleSetupTimeInput = () => {
        const clone = [...data.setup, {startTime:"", endTime:""}]
        setData({...data, setup:clone});
    };

    const handleRunTimeInput = () => {
        const clone = [...data.run, {startTime:"", endTime:""}]
        setData({...data, run:clone});
    };

    const onChangeJobEndTime =(event) =>{
        if(data.jobStartTime && data.jobStartTime > event.target.value){
            setJobTimeErr("End time should be after the start time");
        }else{
            setData({ ...data, [event.target.name] : event.target.value });
            setJobTimeErr('');
        }
    }

    const onChangeEndTime = (event, index, attName, errorData, setError) => {
        let { name, value } = event.target;
        let errors = [...errorData];
        let onChangeValue = [...data[attName]];

        if(onChangeValue[index].startTime && onChangeValue[index].startTime > value){
            errors[index] = "The end time should be after the start time.";
        }else{
            onChangeValue[index][name] = value;
            setData({...data, [attName]:onChangeValue});
            errors[index] = "";
        }

        setError([...errors]);
    };

    const onSubmit = (event) =>{
        event.preventDefault();
        const body = JSON.stringify(data);
        axios.put(`${process.env.REACT_APP_HOST}user/${getUserId()}/job/${job}/manualReport`,
         body,
        {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res => {
            toast.success("Data stored successfully", { autoClose:3000 });
        }).catch(error => {
                console.error(error.response?.data?.message);
        }).finally(() => {
            setData({...initialState});
            setTimeout(() =>{
                window.location.reload();
            },3000)
        });
    }

    const fetchJobList = (machineId) =>{
        axios.get(`${process.env.REACT_APP_HOST}user/${getUserId()}/active/job?machineId=${machineId}`)
        .then(res => {
            setJobList(res.data.content);
        }).catch(error => {
            console.error(error.response?.data?.message);
        })
    }

    const onSetJobDetails = (jobId) => {
        const job = jobList.find(item => item.id === jobId);

        setData({
            ...data,
            companyName:job.customer?.name,
            newJobNumber:job.jId,
            oldJobNumber:job.oldJobId,
            designName:job.designName,
            length:job.rated?.output,
        })
    }

    const fetchEmployeeList = (departmentId) =>{
        axios.get(`${process.env.REACT_APP_HOST}user/${getUserId()}/department/${departmentId}/employee`)
        .then(res => {
            setEmployeeList(res.data.content);
        }).catch(error => {
            console.error(error.response?.data?.message);
        })
    }

    const fetchInputMaterials = (jobId) =>{
        axios.get(`${process.env.REACT_APP_HOST}user/${getUserId()}/job/${jobId}/inputLoads?status=INITIATED`)
        .then(res => {
            setInputList(res.data.content);
        }).catch(error => {
            console.error(error.response?.data?.message);
        })
    }

    const fetchWastageTypes = (jobId) =>{
        const job = jobList.find(item => item.id === jobId);
        
        axios.get(`${process.env.REACT_APP_HOST}user/${getUserId()}/machine-type/${job.type}/wastage`)
        .then(res => {
            setWastageTypeList(res.data.content);
        }).catch(error => {
            console.error(error.response?.data?.message);
        })
    }

    const fetchDownTimeReasons = () =>{
        axios.get(`${process.env.REACT_APP_HOST}user/${getUserId()}/reason/downtime`)
        .then(res => {
            const types = res.data.content.map(name => ({name}));
            setDownTimeList(types);
        }).catch(error => {
            console.error(error.response?.data?.message);
        })
    }

    return <div id="listView" className={'list-view full-list-view'}>
        <Container className="m-t-8">
            <Form onSubmit={onSubmit}>
                <Row className="w-full pb-4 d-flex">
                    <Col lg={1}><label className="mt-1 text-secondary">Department</label></Col>
                    <Col>
                        <DropDown
                            title={"Department"}
                            displayKey={"name"}
                            data={departmentList}
                            dropDownStyle={`form-control form-control-time-filter name-shift ml-1`}
                            isRequired={true}
                            name={"id"}
                            onChange={(e) =>{ 
                                setDepartment(e.target.value);
                                filterMachineList(e.target.value);
                                fetchEmployeeList(e.target.value);
                                setData({...data, department: e.target.value});
                            }}
                        />
                    </Col>
                    <Col lg={1}><label className="mt-1 w-25 text-secondary">Machines</label></Col>
                    <Col>
                        <DropDown
                            title={"Machine"}
                            displayKey={"name"}
                            data={filteredMachines}
                            dropDownStyle={`form-control form-control-time-filter name-shift ml-1`}
                            isRequired={true}
                            name={"id"}
                            onChange={(e) => { 
                                setMachine(e.target.value);
                                setData({...data, machine: e.target.value});
                                fetchJobList(e.target.value);
                            }}
                        />
                    </Col>
                    <Col lg={1}><label className="mt-1 ml-2 w-25 text-secondary">Jobs</label></Col>
                    <Col>
                        <DropDown
                            title={"Jobs"}
                            displayKey={"jId"}
                            data={jobList}
                            dropDownStyle={`form-control form-control-time-filter name-shift`}
                            isRequired={true}
                            name={"id"}
                            onChange={(e) => { 
                                setJob(e.target.value);
                                onSetJobDetails(e.target.value);
                                fetchInputMaterials(e.target.value);
                                fetchDownTimeReasons(e.target.value);
                                fetchWastageTypes(e.target.value);
                            }}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Card>
                            <label className="font-weight-bold pt-4 pl-3 font-size-18">
                                Company Details
                            </label>
                            <Card.Body>
                                <TextInput mainStyle={'mb-3'} labelStyle={'text-secondary'} inputStyle={'bg-light'} label={'Company Name'} type={'text'} name={'companyName'} value={data.companyName || ''} onChange={handleChange} isRequired={true}/>
                                <Form.Group className="mb-3">
                                    <Form.Label className="mb-3 text-secondary">Job Time</Form.Label>
                                    <div className="d-flex">
                                        <TextInput mainStyle={"w-50 d-flex"} labelStyle={"w-25 mt-2 text-secondary font-size-14"} label={"From"} type={"time"} name={"jobStartTime"} onChange={handleChange} value={data.jobStartTime} inputStyle={"bg-light"} isRequired={true}/>
                                        <TextInput mainStyle={"w-50 d-flex"} labelStyle={"w-25 text-center mt-2 text-secondary font-size-14"} label={"To"} type={"time"} name={"jobEndTime"} onChange={onChangeJobEndTime} value={data.jobEndTime} inputStyle={"bg-light"} isRequired={true}/>  
                                    </div>
                                    <div id={"formErr"} className={"login-warning-msg w-full d-flex justify-content-end"}>{jobTimeErr}</div>  
                                </Form.Group>
                                <Form.Group className="mb-3" >
                                    <Form.Label className="mb-3 text-secondary" >Job No</Form.Label>
                                    <div className="d-flex">
                                        <TextInput mainStyle={"w-50 d-flex"} labelStyle={"w-25 mt-2 text-secondary font-size-14"} label={'Old'} type={"text"} inputStyle={"bg-light"} name={"oldJobNumber"} onChange={handleChange} value={data.oldJobNumber || ''} isRequired={true}/>
                                        <TextInput mainStyle={"w-50 d-flex"} labelStyle={"w-25 text-center mt-2 text-secondary font-size-14"} label={'New'} type={"text"} inputStyle={"bg-light"} name={"newJobNumber"} onChange={handleChange} value={data.newJobNumber || ''} isRequired={true}/>
                                    </div>
                                </Form.Group>
                                <TextInput mainStyle={"mb-3"} labelStyle={"text-secondary"} label={'Design Name'} type={"text"} inputStyle={"bg-light"} name={"designName"} onChange={handleChange} value={data.designName || ''} isRequired={true}/>
                                <TextInput mainStyle={"mb-3"} labelStyle={"text-secondary"} label={'Length'} type={"text"} inputStyle={"bg-light"} name={"length"} onChange={handleChange} value={data.length || ''} isRequired={true}/>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card>
                            <label className="font-weight-bold pt-3 pl-3 font-size-18">
                                Employee Details
                            </label>
                            <Card.Body>
                                {
                                    data && data.employees.map((item,index) => {
                                        return <div key={index} className="manualEntryMargin">
                                            <Form.Group className="d-flex flex-row w-full manualEntryMargin">
                                                <DropDown
                                                    mainStyle={"w-75 mr-2"}
                                                    labelStyle={"text-secondary"}
                                                    showLabel={index === 0 && true}
                                                    title={"Employee"}
                                                    displayKey={"name"}
                                                    data={employeeList}
                                                    dropDownStyle={`form-control bg-light ${index !== 0 && `manualEmployeePicker`}`}
                                                    isRequired={true}
                                                    name={"id"}
                                                    onChange={(event) => handleMultiInputChange(event, index, 'employees')}
                                                />
                                                <div className="d-flex w-full">
                                                    <TextInput mainStyle={"w-50 mr-2"} labelStyle={"text-secondary"} label={index === 0 && 'Start Time'} type={"time"} inputStyle={"bg-light"} name={"startTime"} onChange={(event) => handleMultiInputChange(event, index, 'employees')} value={item.startTime} isRequired={true}/>
                                                    <TextInput mainStyle={"w-50 mr-2"} labelStyle={"text-secondary"} label={index === 0 && 'End Time'} type={"time"} inputStyle={"bg-light"} name={"endTime"} onChange={(event) => onChangeEndTime(event, index, 'employees', employeeEndTimeErr, setEmployeeEndTimeErr)} value={item.endTime} isRequired={true}/>
                                                </div>
                                            </Form.Group>
                                            <div id={"formErr"} className={"login-warning-msg w-full d-flex justify-content-end mr-2 mt-1"}>{employeeEndTimeErr[index]}</div>
                                        </div>
                                    })
                                }
                                <AddButton name={"ADD NEW EMPLOYEE"} onClick={handleEmployeeInput}/>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <label className="font-weight-bold pt-4 pb-2 font-size-20">
                    Material Details
                </label>
                <Row>
                    <Col>
                        <Card>
                            <label className="font-weight-bold pt-3 pl-2 font-size-18">
                                Input Material
                            </label>
                            {
                                data && data.inputMaterials.map((item,index) => {
                                    return <Card.Body key={index} className="d-flex flex-0 flex-row p-0 pl-2 manualEntryMargin">
                                        <DropDown
                                            mainStyle={"w-50 mr-2"}
                                            labelStyle={"text-secondary"}
                                            showLabel={index === 0 && true}
                                            title={"Name"}
                                            displayKey={"vnsNo"}
                                            data={inputList}
                                            dropDownStyle={`form-control bg-light ${index !== 0 && `manualEmployeePicker`}`}
                                            isRequired={true}
                                            name={"id"}
                                            onChange={(event) => handleMultiInputChange(event, index, 'inputMaterials')}
                                        />
                                        <TextInput mainStyle={"mr-1"} labelStyle={"text-secondary"} label={index === 0 && 'Weight'} type={"text"} inputStyle={"bg-light"} name={"weight"} onChange={(event) => handleMultiInputChange(event, index, 'inputMaterials')} value={item.weight} isRequired={true}/>
                                    </Card.Body>
                                })
                            }
                            <AddButton name={'ADD NEW INPUT'} onClick={handleMaterialInput} buttonStyle={"mb-2 mr-2"}/>
                        </Card>
                    </Col>
                    <Col>
                        <Card>
                            <label className="font-weight-bold pt-3 pl-2 font-size-18">
                                Output Material
                            </label>
                            {
                                data && data.outputMaterials.map((item,index) => {
                                    return <Card.Body key={index} className="d-flex flex-row p-0 pl-2 pr-2 manualEntryMargin">
                                        <TextInput mainStyle={"mr-1"} labelStyle={"text-secondary"} label={index === 0 && 'Name'} type={"text"} inputStyle={"bg-light"} name={"name"} onChange={(event) => handleMultiInputChange(event, index, 'outputMaterials')} value={item.name} isRequired={true}/>
                                        <TextInput labelStyle={"text-secondary"} label={index === 0 && 'Weight'} type={"number"} inputStyle={"bg-light"} name={"weight"} onChange={(event) => handleMultiInputChange(event, index, 'outputMaterials')} value={item.weight} isRequired={true}/>
                                        <TextInput mainStyle={"ml-1"} labelStyle={"text-secondary"} label={index === 0 && 'Length'} type={"number"} inputStyle={"bg-light"} name={"length"} onChange={(event) => handleMultiInputChange(event, index, 'outputMaterials')} value={item.length} isRequired={true}/>
                                    </Card.Body>
                                })
                            }
                            <AddButton name={'ADD NEW OUTPUT'} onClick={handleOutputMaterialInput} buttonStyle={"mb-2 mr-2"}/>
                        </Card>
                    </Col>
                    <Col>
                        <Card>
                            <label className="font-weight-bold pt-3 pl-2 font-size-18">
                                Wastage
                            </label>
                            {
                                data && data.wastage.map((item,index) => {
                                    return <Card.Body key={index} className="d-flex d-block flex-row p-0 pl-2 pr-2 manualEntryMargin">
                                        <DropDown
                                            mainStyle={"w-50 mr-1"}
                                            labelStyle={"text-secondary"}
                                            showLabel={index === 0 && true}
                                            title={"Type"}
                                            displayKey={"name"}
                                            data={wastageTypeList}
                                            dropDownStyle={`form-control bg-light ${index !== 0 && `manualEmployeePicker`}`}
                                            isRequired={true}
                                            name={"type"}
                                            onChange={(event) => {
                                                handleMultiInputChange(event, index, 'wastage');
                                                handleMultiInputChange({target:{ name: "code", value: wastageTypeList.find(item => item.name === event.target.value)?.code}}, index, 'wastage');
                                            }}
                                        />
                                        <TextInput labelStyle={"text-secondary"} label={index === 0 && 'Weight'} type={"number"} inputStyle={"bg-light"} name={"weight"} onChange={(event) => handleMultiInputChange(event, index, 'wastage')} value={item.weight} isRequired={true}/>
                                    </Card.Body>
                                })
                            }
                            <AddButton name={'ADD NEW WASTAGE'} onClick={handleWastageInput} buttonStyle={"mb-2 mr-2"}/>
                        </Card>
                    </Col>
                </Row>
                <label className="font-weight-bold pt-4 pb-2 font-size-20">
                    Operational Metric Details
                </label>
                <Row>
                    <Col>
                        <Card>
                            <label className="font-weight-bold pt-3 pl-2 font-size-18">
                                Downtime
                            </label>
                            {
                                data && data.downTime.map((item, index) =>{
                                    return <div key={index}  className="manualEntryMargin">
                                        <Card.Body className="d-flex flex-row p-0 pl-2 pr-2 manualEntryMargin">
                                            <DropDown
                                                mainStyle={"w-75 mr-1"}
                                                labelStyle={"text-secondary"}
                                                showLabel={index === 0 && true}
                                                title={"Type"}
                                                displayKey={"name"}
                                                data={downTimeList}
                                                dropDownStyle={`form-control bg-light ${index !== 0 && `manualEmployeePicker`}`}
                                                isRequired={true}
                                                name={"type"}
                                                onChange={(event) => handleMultiInputChange(event, index, 'downTime')}
                                            />
                                            <TextInput labelStyle={"text-secondary"} label={index === 0 && 'Start Time'} type={"time"} inputStyle={"bg-light"} name={"startTime"} onChange={(event) => handleMultiInputChange(event, index, 'downTime')} value={item.startTime} isRequired={true}/>
                                            <TextInput mainStyle={"ml-1"} labelStyle={"text-secondary"} label={index === 0 && 'End Time'} type={"time"} inputStyle={"bg-light"} name={"endTime"} onChange={(event) => onChangeEndTime(event, index, 'downTime', downTimeErr, setDownTimeErr)} value={item.endTime} isRequired={true}/>
                                        </Card.Body>
                                        <div id={"formErr"} className={"login-warning-msg w-full d-flex justify-content-end mr-2 mt-1"}>{downTimeErr[index]}</div>
                                    </div>
                                })
                            }
                            <AddButton name={'ADD DOWNTIME'} onClick={handleDowntimeInput} buttonStyle={"mb-2 mr-2"}/>
                        </Card>
                    </Col>
                    <Col>
                        <Card>
                            <label className="font-weight-bold pt-3 pl-2 font-size-18">
                                Setup time
                            </label>
                            {
                                data && data.setup.map((item,index) =>{
                                    return <Card.Body key={index} className="p-0 pl-2 manualEntryMargin">
                                        <div className="d-flex w-full manualEntryMargin">
                                            <TextInput mainStyle={"w-50 mr-2"} labelStyle={"text-secondary"} label={index === 0 && 'Start Time'} type={"time"} inputStyle={"bg-light"} name={"startTime"} onChange={(event) => handleMultiInputChange(event, index, 'setup')} value={item.startTime} isRequired={true}/>
                                            <TextInput mainStyle={"w-50 mr-2"} labelStyle={"text-secondary"} label={index === 0 && 'End Time'} type={"time"} inputStyle={"bg-light"} name={"endTime"} onChange={(event) => onChangeEndTime(event, index, 'setup', setupTimeErr, setSetupTimeErr)} value={item.endTime} isRequired={true}/>
                                        </div>
                                        <div id={"formErr"} className={"login-warning-msg w-full d-flex justify-content-end mr-2 mt-1"}>{setupTimeErr[index]}</div>
                                    </Card.Body>
                                })
                            }
                            <AddButton name={'ADD SETUP TIME'} onClick={handleSetupTimeInput} buttonStyle={"mb-2 mr-2"}/>
                        </Card>
                    </Col>
                    <Col>
                        <Card>
                            <label className="font-weight-bold pt-3 pl-2 font-size-18">
                                Run time
                            </label>
                            {
                                data && data.run.map((item,index) =>{
                                    return <Card.Body key={index} className="p-0 pl-2 pr-2 manualEntryMargin">
                                        <div className="d-flex w-full manualEntryMargin">
                                            <TextInput mainStyle={"w-50 mr-2"} labelStyle={"text-secondary"} label={index === 0 && 'Start Time'} type={"time"} inputStyle={"bg-light"} name={"startTime"} onChange={(event) => handleMultiInputChange(event, index, 'run')} value={item.startTime} isRequired={true}/>
                                            <TextInput mainStyle={"w-50 mr-2"} labelStyle={"text-secondary"} label={index === 0 && 'End Time'} type={"time"} inputStyle={"bg-light"} name={"endTime"} onChange={(event) => onChangeEndTime(event, index, 'run', runTimeErr, setRunTimeErr)} value={item.endTime} isRequired={true}/>
                                        </div>
                                        <div id={"formErr"} className={"login-warning-msg w-full d-flex justify-content-end mr-2 mt-1"}>{runTimeErr[index]}</div>
                                    </Card.Body>
                                })
                            }
                            <AddButton name={'ADD RUN TIME'} onClick={handleRunTimeInput} buttonStyle={"mb-2 mr-2"}/>
                        </Card>
                    </Col>
                </Row>
                <div className="w-full pt-3 pb-3 d-flex flex-row-reverse">
                    <button type="submit" className="manualEntryAddBtn">
                        <span>Send to ERP</span>
                    </button>
                </div>
            </Form>
        </Container>
    </div>

}

export default ManualDataEntry;